import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeChangePhoneNumberRequestSmsParams = {
  phoneNumber: string;
};

type TypeChangePhoneNumberRequestSmsResponse = {
  code: string;
  message: string;
};

/** @description비밀번호 변경을 위한 인증번호 요청 api에 사용되는 커스텀 훅 */
export const useChangePhoneNumberRequestSms = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeChangePhoneNumberRequestSmsParams) => {
      const endpoint = '/labor-accounts/phone-verification/for-modify-phone-number';
      return axiosInstance.post(endpoint, params);
    },
  });

  const requestChangePhoneNumberRequestSms = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeChangePhoneNumberRequestSmsParams;
    onSuccess?: (res: TypeChangePhoneNumberRequestSmsResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestChangePhoneNumberRequestSms;
};
